import { array, number } from 'yup'
import { safify } from '../utils/safify'

export const sourceMaterialIds = array()
  .of(number())
  .default([])
  .meta({ label: 'Select source material', autoFill: true, featureFlags: { brand_kits: false } })
  .transform(safify)
